import { render } from "./CoursePopular.vue?vue&type=template&id=400e1e0b&scoped=true"
import script from "./CoursePopular.vue?vue&type=script&lang=js"
export * from "./CoursePopular.vue?vue&type=script&lang=js"

import "./CoursePopular.vue?vue&type=style&index=0&id=400e1e0b&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400e1e0b"]])

export default __exports__